module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("John lives in a small town in the west of Scotland, where he was born and bred. He is a dedicated family man who is revelling in his new found role as a first-time grandad. When he’s not working hard for a living, he likes to spend his spare time writing (short stories mostly). He likes to read (and write) about horror, mysteries and things unexplained. Having said that, he will read (and write) about mostly anything. Apart from romantic affairs of the heart slushy stuff that is (he leaves that sort of stuff to others), he likes graphic, dark and somewhat twisted and bizarre stories that are meant to shock the reader. Stories that make you go, “Whoa…what the hell did I just read!!!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0